// Module
var code = `<table class="table">
    <tbody>
    <tr>
      <td>&nbsp;</td>
      <td>Amount:</td>
      <td>
        <cash ng-model="\$ctrl.operation.amount"
              ng-disabled="true"></cash>
      </td>
    </tr>
    <tr>
      <td>&nbsp;</td>
      <td>Date paid:</td>
      <td>
        <date output-format="date"
              ng-model="\$ctrl.operation.processedOn"
              ng-disabled="true"></date>
      </td>
    </tr>
    <tr>
      <td>&nbsp;</td>
      <td>Official Receipt:</td>
      <td>
        <input type="text"
               disabled
               ng-model="\$ctrl.getReceiptOrInvoice()">
      </td>
    </tr>
    </tbody>
  </table>
  <table class="table amortization-table"
         ng-if="\$ctrl.amortizations && \$ctrl.amortizations.length > 0">
    <thead>
    <tr>
      <th>No.</th>
      <th>Status</th>
      <th>Principal</th>
      <th>Interest</th>
      <th>CBU</th>
      <th>PF</th>
      <th>TP</th>
      <th>Past-due Interest</th>
      <th>Past-due Maturity Interest</th>
      <th>Penalties</th>
      <th>Penalty maturity</th>
      <th>Custom Fees</th>
      <th>Total</th>
      <th>&nbsp;</th>
    </tr>
    </thead>
    <tbody ng-repeat="a in \$ctrl.amortizations | orderBy:'lineNumber'">
    <tr class="initial-row">
      <td>{{a.lineNumber}}.</td>
      <td class="status-col" ng-class="{'red': a.status_initial === 'OVERDUE'}">{{a.status}}</td>
      <td><input type="text" disabled
                 ng-model="a.principalAmount"/></td>
      <td><input type="text" disabled
                 ng-model="a.interestAmount"/></td>
      <td><input type="text" disabled
                 ng-model="a.cbuChargeAmount"/></td>
      <td><input type="text" disabled
                 ng-model="a.pfChargeAmount"/></td>
      <td><input type="text" disabled
                 ng-model="a.tpChargeAmount"/></td>
      <td><input type="text" disabled
                 ng-model="a.pastDueInterestAmount"/></td>
      <td><input type="text" disabled
                 ng-model="a.pastDueMaturityInterestAmount"/></td>
      <td class="penalties-column">
        <input type="text" disabled ng-model="a.penaltyAmount"/></td>
      <td class="penalties-column">
        <input type="text" disabled ng-model="a.penaltyMaturityAmount"/></td>
      <td><input type="text" disabled
                 ng-model="a.customFeesAmount"/></td>
      <td class="paid-column">
        <input type="text" disabled ng-model="a.amortizationAmount"/></td>
    </tr>
    </tbody>
    <tfoot>
      <tr class="initial-row">
        <td>SUMMARY</td>
        <td></td>
        <td><input type="text" disabled
                   ng-model="\$ctrl.summary.principal"/></td>
        <td><input type="text" disabled
                   ng-model="\$ctrl.summary.interest"/></td>
        <td><input type="text" disabled
                   ng-model="\$ctrl.summary.cbuCharge"/></td>
        <td><input type="text" disabled
                   ng-model="\$ctrl.summary.pfCharge"/></td>
        <td><input type="text" disabled
                   ng-model="\$ctrl.summary.tpCharge"/></td>
        <td><input type="text" disabled
                   ng-model="\$ctrl.summary.pastDueInterest"/></td>
        <td><input type="text" disabled
                   ng-model="\$ctrl.summary.pastDueMaturityInterest"/></td>
        <td class="penalties-column">
          <input type="text" disabled ng-model="\$ctrl.summary.penalty"/></td>
        <td class="penalties-column">
          <input type="text" disabled ng-model="\$ctrl.summary.penaltyMaturity"/></td>
        <td><input type="text" disabled
                   ng-model="\$ctrl.summary.customFees"/></td>
        <td class="paid-column">
          <input type="text" disabled
                 ng-model="\$ctrl.summary.total"/>
        </td>
      </tr>
    </tfoot>
</table>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/common/paid-amortizations.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;